// extracted by mini-css-extract-plugin
export var container = "_dj-0";
export var containerTopRight = "_dj-1";